"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMessageAdmin = void 0;
var antd_1 = require("antd");
var useMessageAdmin = function () {
    var _a = antd_1.message.useMessage(), messageApi = _a[0], contextHolder = _a[1];
    var showSuccess = function (content) {
        messageApi.success(content);
    };
    var showError = function (content) {
        messageApi.error(content);
    };
    return { showSuccess: showSuccess, showError: showError, contextHolder: contextHolder };
};
exports.useMessageAdmin = useMessageAdmin;
